import { render, staticRenderFns } from "./DetalleGrupo.vue?vue&type=template&id=f221aaec&scoped=true"
import script from "./DetalleGrupo.vue?vue&type=script&lang=js"
export * from "./DetalleGrupo.vue?vue&type=script&lang=js"
import style0 from "./DetalleGrupo.vue?vue&type=style&index=0&id=f221aaec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f221aaec",
  null
  
)

export default component.exports